module.exports = __webpack_public_path__ + "b4da83791dc31904ccb660db7715cd24.png";